module.exports = __webpack_public_path__ + "static/img/title-bg.33d389f4.png";